import React from 'react';
import { cn } from '../../utils/cn';

/**
 * AppShell — squelette principal d'une application.
 *
 *   <AppShell>
 *     <AppShell.Sidebar>...</AppShell.Sidebar>
 *     <AppShell.Topbar>...</AppShell.Topbar>
 *     <AppShell.Main>...</AppShell.Main>
 *   </AppShell>
 */

export function AppShell({ className, children, ...rest }) {
  return (
    <div className={cn('flex h-screen bg-bg', className)} {...rest}>
      {children}
    </div>
  );
}

function Body({ className, children }) {
  return <div className={cn('flex-1 flex flex-col min-w-0', className)}>{children}</div>;
}

function Main({ className, children, ...rest }) {
  return (
    <main className={cn('flex-1 overflow-y-auto overflow-x-hidden min-w-0', className)} {...rest}>
      {children}
    </main>
  );
}

AppShell.Body = Body;
AppShell.Main = Main;

export default AppShell;
